import { isPlainObject } from '@atlassian/mpac-utils/object';
export const algoliaFacetMap = {
  product: 'version.compatibilities.applicationKey',
  price: {
    paid: 'version.paid',
    freeStarterTier: 'freeStarterTierStatus'
  },
  hosting: 'version.compatibilities.hosting',
  trustSignals: {
    cloudFortified: 'programs.cloudFortified.status',
    bugBountyParticipant: 'programs.bugBountyParticipant'
  },
  // // has to be added as direct numericFilters instead of facetFilter (numericFilters: ['ratings.avgStars >= 3'])
  // // https://www.algolia.com/doc/api-reference/api-parameters/numericFilters/
  // ratings: {
  //   '3StarAbove': 'ratings.avgStars >= 3',
  //   '2StarAbove': 'ratings.avgStars >= 2',
  //   '1StarAbove': 'ratings.avgStars >= 1',
  //   noRating: 'ratings.avgStars = 0',
  // },
  other: {
    stable: 'version.stable',
    vendorSupported: 'version.supported'
  },
  categories: 'categories',
  useCases: 'categories',
  hidden: 'hidden',
  canonicalVersion: 'version.canonicalVersion',
  deployments: 'deployments',
  topVendor: 'vendor.isTopVendor',
  latestOfHosting: 'version.latestOfHosting',
  isAtlassian: 'vendor.isAtlassian',
  marketplaceType: 'version.marketplaceType',
  marketingLabels: 'marketingLabels',
  pluginSystemVersion: 'version.pluginSystemVersion'
};
const defaultFacetsValues = {
  [algoliaFacetMap.hidden]: 'notHidden',
  [algoliaFacetMap.canonicalVersion]: 'true'
};

/**
 * Transform the filters to match the Algolia index.
 * @param {SelectedOptions} filters - The filters to transform.
 * @return {string[]} - The transformed filters.
 */
export const transformFilters = (filters, sortFilters) => {
  // Transform each filter option
  const transformedFilters = Object.entries(filters).map(_ref => {
    let [filterId, filterOptions] = _ref;
    const filterOptionsValue = Array.isArray(filterOptions) ? filterOptions : [filterOptions];
    return filterOptionsValue.map(filterOption => isPlainObject(algoliaFacetMap[filterId]) ? // If the specified filterId maps to an object in algoliaFacetMap, use the id of the filterOption as algolia facet key
    "".concat(algoliaFacetMap[filterId][filterOption.id], ":").concat(filterOption.value) : "".concat(algoliaFacetMap[filterId], ":").concat(filterOption.value));
  });

  // Add default facet filtering
  transformedFilters.push(Object.entries(defaultFacetsValues).map(_ref2 => {
    let [filterId, value] = _ref2;
    return "".concat(filterId, ":").concat(value);
  }));
  if (sortFilters) {
    transformedFilters.push(Object.entries(sortFilters).map(_ref3 => {
      let [filterId, value] = _ref3;
      return "".concat(filterId, ":").concat(value);
    }));
  }

  // Flatten the array of arrays into a single array
  return transformedFilters.flat();
};